export enum AssignmentToType {
  Team = 'TEAM',
  User = 'USER',
  Queue = 'QUEUE',
  Field = 'FIELD',
}
